export const Bet_History_Filter_Types = Object.freeze({
    Cancelled: 'Cancelled',
    All: 'All',
    Reverse: 'Reverse',
    Hold: 'Hold',
    Decline: 'Declined',
    Approved: 'Approved',
    Pending: 'Pending',
})